import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';
import { Mail, Loader2, X } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const EmailVerificationBanner = () => {
  const { user, token } = useAuth();
  const [sending, setSending] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!user || user.email_verified || user.is_admin || dismissed) return null;

  const resend = async () => {
    setSending(true);
    try {
      await axios.post(`${API}/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      toast.success('Email de verificación reenviado');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al reenviar');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-4 mb-6 flex items-center justify-between" data-testid="email-verification-banner">
      <div className="flex items-center gap-3">
        <Mail className="w-5 h-5 text-yellow-500 flex-shrink-0" />
        <div>
          <p className="text-yellow-400 text-sm font-medium">Verifica tu email</p>
          <p className="text-zinc-500 text-xs">Revisa tu bandeja de entrada para activar todas las funciones</p>
        </div>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          onClick={resend}
          disabled={sending}
          className="border-yellow-500/30 text-yellow-400 hover:bg-yellow-500/10 text-xs"
          data-testid="resend-verification-btn"
        >
          {sending ? <Loader2 className="w-3 h-3 animate-spin" /> : 'Reenviar'}
        </Button>
        <button onClick={() => setDismissed(true)} className="text-zinc-600 hover:text-zinc-400">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default EmailVerificationBanner;
